import { Theme } from "@mui/material";

export function resolveMprcRadiusSize(borderRadius?: MprcRadiusSize): string | number | undefined {
    return borderRadius == undefined
        ? undefined
        : borderRadius == "xs"
            ? "8px"
            : borderRadius == "sm"
                ? "16px"
                : borderRadius == "md"
                    ? "32px"
                    : borderRadius == "lg"
                        ? "48px"
                        : borderRadius == "inherit"
                            ? "inherit"
                            : 0;
}

export function resolveMprcMargin(theme: Theme, margin: MprcMargin): string | number {
    return margin == "dense"
        ? theme.spacing(1)
        : margin == "normal"
            ? theme.spacing(2)
            : margin == "large"
                ? theme.spacing(4)
                : 0;
}
